import { Component, HostListener, Input, OnInit, AfterViewInit, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputOtpModule } from 'primeng/inputotp';
import { Customer, Plan, SalesPartner } from '../../../../../../landingpage/models/src';
import { SharedModule } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CustomerService } from '../../../../../data-access/api-client/src';
import { CommonModule } from '@angular/common';
import { PLANS_HELPER } from '@oneqrew-partnertool/utils';
import { Store } from '@ngrx/store';
import { setCustomer, setPlan } from '../../../../../../landingpage/core/src';
import { CustomerOffer } from '../../../../../data-access/api-client/src/lib/model/customerOffer';
import { CustomerVerificationService } from '../../../../../../landingpage/utils/src/lib/customer-verification.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'customer-verification-dialog',
  standalone: true,
  imports: [FormsModule, InputOtpModule, SharedModule, ButtonModule, CommonModule],
  templateUrl: './customer-verification-dialog.component.html',
  styleUrls: ['./customer-verification-dialog.component.scss']
})
export class CustomerVerificationDialogComponent implements OnInit, AfterViewInit {
  class = 'customer-verification-dialog';
  @Input() customerOfferId!: number;
  @Output() closeDialog = new EventEmitter<void>();
  otpCode!: string;
  invalidOtp: boolean = false;
  isVerifying: boolean = false;
  isResendingOtp: boolean = false;

  userID: string = '';
  customer!: Customer;
  @Input() isNewPlanPage = false;
  offerFormValid!: boolean;
  canRenderSummary = false;
  plan!: Plan;
  defaultAdditionalModule!: number[];

  constructor(
    private cdr: ChangeDetectorRef,
    private customerService: CustomerService,
    private store: Store,
    private customerVerificationService: CustomerVerificationService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.canRenderSummary = true;
    this.cdr.detectChanges();
  }

  verifyOtp() {
    this.invalidOtp = false;
    const otpCodeTrimmed = this.otpCode.trim(); // workaround value has whitespace on end
    if (otpCodeTrimmed.length == 6) {
      this.isVerifying = true;
      this.customerService.verifyOtpCustomerOffer(this.customerOfferId, otpCodeTrimmed).subscribe({
        next: (offer) => {
          this.isVerifying = false;
          if (offer) {
            const accessCode = this.route.snapshot.queryParams['accessCode'];
            sessionStorage.setItem('accessCode', accessCode);
            sessionStorage.setItem('offerId', offer.id!!.toString());
            this.customerVerificationService.set(offer.id!!, accessCode, offer);
            this.setPlan(offer);
            this.setCustomer(offer);
            this.closeDialog.emit();
          }
        },
        error: () => {
          this.isVerifying = false;
          this.invalidOtp = true;
        }
      });
    }
  }

  resedOtp() {
    this.isResendingOtp = true;

    this.customerService.resendOtpCustomerOffer(this.customerOfferId).subscribe(() => {
      this.isResendingOtp = false;
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): void {
    $event.returnValue = 'Beim erneuten Laden der Seite gehen die ausgewählten Module und der Plan verloren.';
  }

  private setPlan(offer: CustomerOffer) {
    const oneqrewSubscription = offer?.oneqrewSubscription;
    const additionalModules = oneqrewSubscription?.extraModules
      ?.filter((module) => module.isExtra)
      .map((m) => ({ ...m, price: m.monthlyPrice }));
    const regularModules = oneqrewSubscription?.extraModules
      ?.filter((module) => !module.isExtra && module.name !== 'Grundmodul')
      .map(({ isExtra, ...module }) => module);

    const startDate = oneqrewSubscription?.startOfContract ? this.getPlanStartDate(oneqrewSubscription.startOfContract) : null;

    const plan = {
      id: oneqrewSubscription?.id,
      ...PLANS_HELPER.getByType(offer.oneqrewSubscription?.productPackage?.type ?? ''),
      devicesCount: oneqrewSubscription?.amountDevices,
      workStationCount: oneqrewSubscription?.amountWorkspaces,
      clientsCount: oneqrewSubscription?.amountClients,
      price: oneqrewSubscription?.productPackage?.monthlyPrice,
      modules: regularModules,
      additionalModules,
      legacyProductDiscount: oneqrewSubscription?.legacyProductDiscount,
      cloudVersion: oneqrewSubscription?.isCloudVersion,
      startDate: startDate
    };
    this.store.dispatch(setPlan(plan));
  }

  /**
   * Offer and Order subscription startOfContract are
   * one month ahead of user selected startDate.
   * TODO revisit rewrite plan and subscription match properties
   * and add additional info like separate startDate from startOfContract
   */
  private getPlanStartDate(startOfContract: string): Date {
    const startDate = new Date(startOfContract);
    startDate.setMonth(startDate.getMonth() - 1);
    return startDate;
  }

  private setCustomer(offer: CustomerOffer) {
    const customer = offer?.oneqrewSubscription?.customer;
    const customerCD = customer?.contactDetails;
    const updatedCustomer: Customer = {
      ...this.customer,
      firstName: offer.firstName,
      lastName: offer.lastName,
      email: offer.email,
      company: offer?.companyName ?? customer?.contactDetails?.companyName,
      street: customerCD?.street ?? '',
      addressTwo: customerCD?.addressExtra ?? '',
      postCode: customerCD?.postalCode ?? '',
      city: customerCD?.city ?? '',
      salutation: customerCD?.salutation,
      salutationOpener: customerCD?.salutationOpener,
      bsNumber: customerCD?.bsNumber ?? '',
      ustIdNr: customerCD?.ustIdNr ?? '',
      salesPartner: (offer?.salesPartner ?? {}) as SalesPartner,
      phoneNr: customerCD?.phoneNr,
      mobilePhoneNr: customerCD?.mobilePhoneNr,
      knr: customerCD?.bsNumber ?? customer?.knr,
      id: customer?.id ?? 0,
      legacyProductName: customer?.legacyProductName ?? ''
    };
    this.store.dispatch(setCustomer(updatedCustomer));
  }
}
